import { Component } from '@niknevis/vue-modules'
import QCheckbox from 'quasar/src/components/checkbox/QCheckbox.js';import QSeparator from 'quasar/src/components/separator/QSeparator.js';
import Vue from 'vue'

export interface TesTableGrid {
  [key: string]: any
}

@Component
export class TesTableGrid extends Vue {
  __getGridBodyRow(h, row, pageIndex) {
    const
      key = this.getRowKey(row),
      selected = this.isRowSelected(key),
      itemSlot = this.$scopedSlots.item,
      bodySlot = this.$scopedSlots.body,
      scope = this.__getBodyScope({
        key,
        row,
        pageIndex,
        grid: this.grid
      }),
      bodyScope = this.__getBodyScope({
        key,
        row,
        pageIndex,
        grid: this.grid,
        __trClass: selected ? 'selected' : ''
      })

    if (itemSlot) {
      return itemSlot(scope)
    }

    if (bodySlot !== void 0) {
      return bodySlot(bodyScope)
    }

    if (this.rowComponent) {
      return h(this.rowComponent, {
        key,
        props: {
          ...bodyScope,
          key: void 0,
          tesKey: bodyScope.key
        }
      })
    }

    const
      bodyCell = this.$scopedSlots['body-cell'],
      child = this.computedCols.map(col => {
        const
          bodyCellCol = this.$scopedSlots[`body-cell-${col.name}`],
          slot = bodyCellCol !== void 0 ? bodyCellCol : bodyCell

        return slot !== void 0
          ? slot(this.__getBodyCellScope({ key, row, pageIndex, col }))
          : h('div', {
            staticClass: 'q-table__grid-item-row'
          }, [
            h('div', { staticClass: 'q-table__grid-item-title' }, [col.label]),
            h('div', { staticClass: 'q-table__grid-item-value' }, [
              this.getCellValue(col, row)
            ])
          ])
      })

    if (this.hasSelectionMode === true) {
      const slot = this.$scopedSlots['body-selection']
      const content = slot !== void 0
        ? slot(scope)
        : [
          h(QCheckbox, {
            props: {
              value: scope.selected,
              color: this.color,
              dark: this.isDark,
              dense: this.dense
            },
            on: {
              input: (adding, evt) => {
                this.__updateSelection([scope.key], [scope.row], adding, evt)
              }
            }
          })
        ]

      child.unshift(
        h('div', { staticClass: 'q-table__grid-item-row' }, content),
        h(QSeparator, { props: { dark: this.isDark } })
      )
    }

    const data = {
      staticClass: 'q-table__grid-item-card' + this.cardDefaultClass,
      class: this.cardClass,
      style: this.cardStyle,
      on: {} as any
    }

    if (this.qListeners['row-click'] !== void 0) {
      data.class['cursor-pointer'] = true
      data.on.click = evt => {
        this.$emit('row-click', evt, row, pageIndex)
      }
    }

    if (this.qListeners['row-dblclick'] !== void 0) {
      data.class['cursor-pointer'] = true
      data.on.dblclick = evt => {
        this.$emit('row-dblclick', evt, row, pageIndex)
      }
    }

    if (this.qListeners['row-contextmenu'] !== void 0) {
      data.class['cursor-pointer'] = true
      data.on.contextmenu = evt => {
        this.$emit('row-contextmenu', evt, row, pageIndex)
      }
    }

    return h('div', {
      staticClass: 'q-table__grid-item col-xs-12 col-sm-6 col-md-4 col-lg-3',
      class: scope.selected === true ? 'q-table__grid-item--selected' : ''
    }, [
      h('div', data, child)
    ])
  }

  __getGridBody(h) {
    return h('div', {
      staticClass: 'q-table__grid-content row',
      class: this.cardContainerClass,
      style: this.cardContainerStyle
    }, this.computedRows.map((row, pageIndex) => {
      return this.__getGridBodyRow(h, row, pageIndex)
    }))
  }
}
